import request from '../request';

// 机具管理-统计
export function device_sn_statistical() {
  return request({
    url: `/device/sn/statistical`,
    method: `get`
  });
}

// 机具申领-统计
export function device_apply_statistical() {
  return request({
    url: `/direct/sale/machine/apply/machine/count`,
    method: `get`
  });
}


// 机具转让列表
export function device_deliver_list(params) {
  return request({
    url: `/device/deliver/list`,
    method: `get`,
    params
  });
}

// 查询可转让机具
export function device_deliver_query(params) {
  return request({
    url: `/device/deliver/query`,
    method: `get`,
    params
  });
}

// 机具管理-代理授权的产品列表
export function device_sn_product_list() {
  return request({
    url: `/device/sn/product/list`,
    method: `get`
  });
}

// 新增机具转让订单
export function device_deliver_add(data) {
  return request({
    url: `/device/deliver/add`,
    method: `post`,
    data
  });
}

// 待接收订单数量
export function device_deliver_count_receive() {
  return request({
    url: `/device/deliver/count/receive`,
    method: `get`
  });
}

// 机具转让-接收列表
export function device_deliver_receiver_list(params) {
  return request({
    url: `/device/deliver/receiver/list`,
    method: `get`,
    params
  });
}

// 根据品牌id查询转让机具
export function device_deliver_byProductId(params) {
  return request({
    url: `/device/deliver/byProductId/${params.id}`,
    method: `get`,
    params
  });
}

//机具申领-分拣订单sn
export function device_apply_sn_list(params) {
  return request({
    url: `/direct/sale/machine/apply/sn/list`,
    method: `get`,
    params
  });
}


// 机具管理列表
export function device_sn_list(params) {
  return request({
    url: `/device/sn/list`,
    method: `get`,
    params
  });
}

// 机具管理列表
export function device_sn_list_zhy(params) {
  return request({
    url: `/device/sn/zhy/list`,
    method: `get`,
    params
  });
}

// 机具管理列表-详情
export function device_sn_detail(id) {
  return request({
    url: `/device/sn/detail/${id}`,
    method: `get`
  });
}
export function device_sn_detail_gt(params) {
  return request({
    url: `/device/getConfigMarket`,
    method: `get`,
    params
  });
}

// 拒绝或撤销订单
export function device_deliver_refused_or_undo(data) {
  return request({
    url: `/device/deliver/refused/or/undo`,
    method: `post`,
    data
  });
}

// 接收机具
export function device_deliver_receiver(id) {
  return request({
    url: `/device/deliver/receiver/${id}`,
    method: `post`
  });
}

// 直营订单申请-拒绝或撤销
export function device_apply_refused_or_undo(data) {
  return request({
    url: `/direct/sale/machine/apply/refused/or/undo`,
    method: `post`,
    data
  });
}

// 直营订单申请-接收机具
export function device_apply_receiver(data) {
  return request({
    url: `/direct/sale/machine/apply/examine/by/out`,
    method: `post`,
    data
  });
}

// 检查转让单是否有考核过期的机具
export function device_deliver_check_examine(id) {
  return request({
    url: `/device/deliver/check/examine/${id}`,
    method: `get`,
  });
}

// ---------------------------------扣款记录------------------------------------
// 过期扣款列表
export function device_deduct_invalid_list(params) {
  return request({
    url: `/device/deduct/invalid/list`,
    method: `get`,
    params,
  });
}

// 过期扣款详情
export function device_deduct_invalid_detail(params) {
  return request({
    url: `/device/deduct/invalid/detail`,
    method: `get`,
    params,
  });
}

// 过期扣款列表统计
export function device_deduct_invalid_sum(params) {
  return request({
    url: `/device/deduct/invalid/sum`,
    method: `get`,
    params,
  });
}


// 伪激活列表
export function device_deduct_achieve_list(params) {
  return request({
    url: `/device/deduct/achieve/list`,
    method: `get`,
    params,
  });
}

// 伪激活详情
export function device_deduct_achieve_detail(params) {
  return request({
    url: `/device/deduct/achieve/detail`,
    method: `get`,
    params,
  });
}

// 伪激活列表统计
export function device_deduct_achieve_sum(params) {
  return request({
    url: `/device/deduct/achieve/sum`,
    method: `get`,
    params,
  });
}

// 机具转让-产品列表
export function device_deliver_agent_product_list(params) {
  return request({
    url: `/device/deliver/agent/product/list`,
    method: `get`,
    params,
  });
}

// 机具申领-产品列表
export function device_apply_agent_product_list(params) {
  return request({
    url: `/direct/sale/machine/apply/agent/product/list`,
    method: `get`,
    params,
  });
}

// 机具申领-产品列表
export function device_apply_org_product_list(params) {
  return request({
    url: `/direct/sale/machine/apply/org/product/list`,
    method: `get`,
    params,
  });
}

// 机具转让-箱号列表
export function device_deliver_sn_box_list(params) {
  return request({
    url: `/device/deliver/sn/box/list`,
    method: `get`,
    params,
  });
}

// 机具转让-号段选择-核查数量
export function device_deliver_sn_by_part(params) {
  return request({
    url: `/device/deliver/sn/by/part`,
    method: `get`,
    params,
  });
}

// 机具转让-SN列表(按箱)
export function device_deliver_sn_by_box(params) {
  return request({
    url: `/device/deliver/sn/by/box`,
    method: `get`,
    params,
  });
}

// 机具转让-转让(校验)
export function device_deliver_sn_verify(data) {
  return request({
    url: `/device/deliver/sn/verify`,
    method: `post`,
    data,
  });
}

// 机具转让-确认详情
export function device_deliver_sn_list_detail(data) {
  return request({
    url: `/device/deliver/sn/list/detail`,
    method: `post`,
    data,
  });
}

// 根据APPID或手机号获取用户信息
export function device_deliver_search_agent(params) {
  return request({
    url: `/device/deliver/search/agent`,
    method: `get`,
    params
  });
}

// 获取活动方案筛选器
export function device_product_superior_market(params) {
  return request({
    url: `/device/product/superior/market/select`,
    method: `get`,
    params
  });
}
export function device_product_superior_market_gt(params) {
  return request({
    url: `/device/getPolicyList`,
    method: `get`,
    params
  });
}
export function device_product_superior__gt_rate(sn) {
  return request({
    url: `device/queryXyfRateAcitivity/${sn} `,
    method: `get`,
  });
}
export function device_product_superior_gt_llk(sn) {
  return request({
    url: `device/queryXyfViplist/${sn} `,
    method: `get`,
  });
}

export function device_product_superior_market_gt_mi(params) {
  return request({
    url: `/device/getTermPolicyList`,
    method: `get`,
    params
  });
}
export function device_product_superior__gt_rate_mi(sn) {
  return request({
    url: `device/queryXyfRateAcitivity/${sn} `,
    method: `get`,
  });
}
export function device_product_superior_gt_llk_mi(sn) {
  return request({
    url: `device/queryXyfMiViplist/${sn} `,
    method: `get`,
  });
}

export function device_sn_superior_xyf_config_mi(data) {
  return request({
    url: `/device/submitXyfMi`,
    method: `post`,
    data
  });
}

// 设备SN配置活动
export function device_sn_superior_config(data) {
  return request({
    url: `/device/sn/superior/config/submit`,
    method: `post`,
    data
  });
}
export function device_sn_superior_xyf_config(data) {
  return request({
    url: `/device/submitXyf`,
    method: `post`,
    data
  });
}

//  查看产品活动状态
export function device_product_superior_status(params) {
  return request({
    url: `/device/product/superior/status`,
    method: `get`,
    params
  });
}


// --------------- 直营添加机具申请列表 ----------------
// 机具申请-列表
export function device_apply_list(params) {
  return request({
    url: `/direct/sale/machine/apply/page`,
    method: `get`,
    params
  });
}

// --------------- 达标跟进 ----------------
// 达标跟进-分页查询（还可以达标的机器列表）
export function achieve_pursue_page(params) {
  return request({
    url: `/direct/sale/data/achieve/pursue/page`,
    method: `get`,
    params
  });
}

// --------------- 奖励申请 ----------------
// 奖励申请-直属下级分页查询
export function reward_subordinate_page(params) {
  return request({
    url: `/direct/sale/reward/apply/subordinate/page`,
    method: `get`,
    params
  });
}

// 奖励申请-合伙人机器列表
export function reward_machine_list(params) {
  return request({
    url: `/direct/sale/reward/apply/machine/list`,
    method: `get`,
    params
  });
}

// 奖励申请-合伙人业绩（目前业绩/底线差距）
export function reward_performance(params) {
  return request({
    url: `/direct/sale/reward/apply/performance`,
    method: `get`,
    params
  });
}

// 奖励申请-提交申请
export function reward_apply_submit(data) {
  return request({
    url: `/direct/sale/reward/apply/submit`,
    method: `post`,
    data
  });
}

// 奖励申请-申请单统计
export function reward_apply_statistical(params) {
  return request({
    url: `/direct/sale/reward/apply/statistical`,
    method: `get`,
    params
  });
}

// 奖励申请-我的申请单分页
export function reward_apply_page(params) {
  return request({
    url: `/direct/sale/reward/apply/page`,
    method: `get`,
    params
  });
}

// --------------- 奖励审批 ----------------
// 奖励审批-副总审批分页
export function reward_audit_vp_page(params) {
  return request({
    url: `/direct/sale/reward/apply/audit/vp/page`,
    method: `get`,
    params
  });
}

// 奖励审批-总经理审批分页
export function reward_audit_gm_page(params) {
  return request({
    url: `/direct/sale/reward/apply/audit/gm/page`,
    method: `get`,
    params
  });
}

// 奖励审批-审批环节明细
export function reward_audit_detail(params) {
  return request({
    url: `/direct/sale/reward/apply/audit/detail`,
    method: `get`,
    params
  });
}

// 奖励审批-晋升申请书图片上传
export function reward_audit_upload(data) {
  return request({
    url: `/common/file/upload`,
    method: `post`,
    headers: {
      'Content-Type': `multipart/form-data`,
    },
    data,
  });
}

// 奖励审批-保存晋升申请书
export function reward_audit_application(data) {
  return request({
    url: `/direct/sale/reward/apply/audit/application`,
    method: `post`,
    data
  });
}

// 奖励审批-副总审批通过
export function reward_audit_vp_pass(data) {
  return request({
    url: `/direct/sale/reward/apply/audit/vp/approve`,
    method: `post`,
    data
  });
}

// 奖励审批-副总审批拒绝
export function reward_audit_vp_refuse(data) {
  return request({
    url: `/direct/sale/reward/apply/audit/vp/reject`,
    method: `post`,
    data
  });
}

// 奖励审批-总经理审批通过
export function reward_audit_gm_pass(data) {
  return request({
    url: `/direct/sale/reward/apply/audit/gm/approve`,
    method: `post`,
    data
  });
}

// 奖励审批-总经理审批拒绝
export function reward_audit_gm_refuse(data) {
  return request({
    url: `/direct/sale/reward/apply/audit/gm/reject`,
    method: `post`,
    data
  });
}

